var _this = this;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { uniqueIdForComponent, getOtherProps } from '../util';
var List = function List(props) {
  var otherProps = getOtherProps(List.propTypes, props);
  var listItems = React.Children.map(props.children, function (child) {
    return child && /*#__PURE__*/React.cloneElement(child, {
      type: props.type,
      className: classNames(props.type === 'default' && !props.linear && 'wds-c-list__item', props.linear && 'wds-c-linear-list__item', child.props.className)
    });
  });
  var id = props.id || uniqueIdForComponent(_this);
  var list = props.type === 'ordered' ? /*#__PURE__*/React.createElement("ol", _extends({}, otherProps, {
    className: classNames('wds-c-list wds-c-list--ordered', props.className)
  }, props.title ? {
    'aria-labelledby': id
  } : {
    'aria-label': props.ariaLabel
  }), listItems) : /*#__PURE__*/React.createElement("ul", _extends({}, otherProps, {
    className: classNames({
      'wds-c-list': (props.type === 'default' || props.type === 'link' || props.type === 'unStyled' || props.type === 'noStyle') && !props.linear,
      'wds-c-list--no-style': props.type === 'noStyle',
      'wds-c-list--unordered': props.type === 'unStyled',
      'wds-c-linear-list': props.linear,
      'wds-c-linear-list--dots': props.linear && props.withDots,
      'wds-c-linear-list--truncate': props.linear && props.truncate
    }, props.className)
  }, props.title ? {
    'aria-labelledby': id
  } : {
    'aria-label': props.ariaLabel
  }), listItems);
  return props.title ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    id: id,
    className: "wds-c-list__header"
  }, props.title), list) : list;
};
List.propTypes = {
  /** Additional classname */
  className: PropTypes.string,
  /** Items in the List, they should be ListItem components */
  children: PropTypes.node,
  /** Specifies the type of the List */
  type: PropTypes.oneOf(['link', 'default', 'unStyled', 'noStyle', 'ordered']),
  /** Title of the List */
  title: PropTypes.string,
  /** Set it to be a linear list */
  linear: PropTypes.bool,
  /** Set it to display a middot as a separator (linear lists) */
  withDots: PropTypes.bool,
  /** Id of the List */
  id: PropTypes.string,
  /** Text to be displayed for screen readers */
  ariaLabel: PropTypes.string,
  /** indicates the list truncates the content instead of wrapping (linear lists) */
  truncate: PropTypes.bool
};
List.defaultProps = {
  type: 'default',
  title: undefined,
  linear: false,
  withDots: false,
  children: undefined,
  className: undefined,
  id: undefined,
  ariaLabel: undefined,
  truncate: false
};
List.displayName = 'List';
export default List;